<template>
  <v-chip
    :color="iconColor"
    label
    variant="flat"
    class="white--text"
  >
    <span
      v-if="evolutionValue >= 0"
      class="mr-1"
    >+</span>{{ evolutionValue | roundNumber(0) }} {{ unite }}
    <v-icon>
      {{ iconName }}
    </v-icon>
    *
  </v-chip>
</template>

<script>
export default {
  name: 'BaseEvolution',
  props: {
    evolutionValue: {
      type: Number,
      required: true
    },
    unite: {
      type: String,
      default: '€/t'
    }
  },
  computed: {   
    iconName () {
      return this.evolutionValue >= 0 ? 'mdi-arrow-top-right' : 'mdi-arrow-bottom-right'
    },

    iconColor () {
      return this.evolutionValue >= 0 ? 'secondary' : '#EC6608'
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
